import { AppConfigs } from '../../common/ApplicationsList/config';

const FEATURED_IDS = [
  'canvas',
  'leoOnline',
  'zoom',
  'oduMobile',
  'courseSearch',
  'degreeWorks',
  'outlook',
  'office365',
];

const Apps = FEATURED_IDS.map((id) => AppConfigs.Apps.find((app) => app.id === id)).filter(Boolean);

export default Apps;
